import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';

import { FocusMeDirective } from '../../../../shared/directives/focus-me.directive';

export const RESPONSE_CONFIRM = 0;
const RESPONSE_CANCEL = 1;

@Component({
	selector: 'copo-claim-utils-dialog-delete-draft',
	templateUrl: './dialog-delete-draft.component.html',
	styleUrl: './dialog-delete-draft.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, MatRippleModule, MatIconModule, NgIf, MatButtonModule, FocusMeDirective, MatDialogModule]
})
export class DialogDeleteDraftComponent {
	draftName: string | undefined;

	constructor(

		private readonly dialogRef: MatDialogRef<DialogDeleteDraftComponent, number>
	) {}

	evtCancel() {
		this.dialogRef.close(RESPONSE_CANCEL);
	}

	evtConfirm() {
		this.dialogRef.close(RESPONSE_CONFIRM);
	}
}
